import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { GlobalServicesService } from './global-services.service';

@Injectable({
  providedIn: 'root'
})

export class EmailServicesService {

  host_api_url = environment.HOST.HOST_API_URL;
  fast_api_url = environment.HOST.FAST_API_URL;

  constructor(private http: HttpClient, private globalService: GlobalServicesService ) { }
  // fast APIs
  getEmailCategoriesFastApi(page = 1, size = 10, orderBy = 'asc', sortBy = 'id'): Observable<HttpResponse<any>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);

    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/email-categories`, {
      params,
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  createEmailCategoryFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/email-categories', payload, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  updateEmailCategoryFastApi(payload: any, categoryId: string): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/email-categories/' + categoryId, payload, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  deleteEmailCategoryFastApi(categoryId: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/email-categories/' + categoryId, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getSpecificEmailCategoryFastApi(categoryId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/email-categories/' + categoryId, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getEmailTemplateFormDataFastApi(emailCategoryId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/email-templates/category/${emailCategoryId}/form-data`, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getTemplatesFastApi(emailCategoryId?: string, templateType?: string): Observable<HttpResponse<any>> {
    let params = new HttpParams();
    if (emailCategoryId) {
      params = params.set('email_category_id', emailCategoryId);
    }
    if (templateType) {
      params = params.set('template_type', templateType);
    }
  
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/email-templates', {
      params,
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  createTemplateFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/email-templates', payload, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  updateTemplateFastApi(payload: any, templateId: string): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(this.fast_api_url + '/email-templates/' + templateId, payload, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  deleteTemplateFastApi(templateId: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(this.fast_api_url + '/email-templates/' + templateId, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getSpecificTemplateFastApi(templateId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.fast_api_url + '/email-templates/' + templateId, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  // Stage Action Send Email API
  stageActionSendEmailFastApi(payload: any,stageId:string,eventId:string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/actions/send-email`, payload, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  // Send Email API
  sendEmailFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/candidates/send-email`, payload, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  sendDocumentationEmailFastApi(payload : any, eventId: string, stageId : string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/actions/send-documentation`, payload, {
      observe: 'response'
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  sendOfferEmailFastApi(payload : any, eventId: string, stageId : string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.fast_api_url + `/events/${eventId}/stages/${stageId}/actions/send-offer`, payload, {
      observe: 'response'
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

}
